import {
  BookOpen01,
  Camera01,
  Clapperboard,
  File02,
  MusicNote01,
} from "@untitledui/icons"
import type { ComponentType } from "react"

// The playing-card "suit" for a track prompt: content type mapped to an
// icon + a corner-mark color. Time-based media are the red suits
// (red-pencil is the sanctioned warm accent), documents the black suits
// (navy). Suit color is decoration only — the card's question text stays
// navy for contrast; the suit's information (the content type) travels
// through the composer's live region and the card eyebrow copy.
export interface Suit {
  icon: ComponentType<{ className?: string }>
  color: string
}

const SUITS: Record<string, Suit> = {
  audio: { icon: MusicNote01, color: "text-batyr-red-pencil" },
  video: { icon: Clapperboard, color: "text-batyr-red-pencil" },
  article: { icon: BookOpen01, color: "text-batyr-navy" },
  photo: { icon: Camera01, color: "text-batyr-navy" },
}

const FALLBACK_SUIT: Suit = { icon: File02, color: "text-batyr-navy" }

// `content_type` is a plain string on the wire; narrow through the map
// with a quiet fallback rather than trusting the union.
export function suitFor(contentType: string): Suit {
  return SUITS[contentType] ?? FALLBACK_SUIT
}
